'use strict';

exports.__esModule = true;
// class for defining the amzn user-agent
exports.default = UserAgent;
// constructor

function UserAgent() {}
// public
UserAgent.prototype.userAgent = 'aws-amplify/0.1.x js';


//////////////////
// WEBPACK FOOTER
// ./~/amazon-cognito-identity-js/lib/UserAgent.js
// module id = 478
// module chunks = 231608221292675